import styled from "styled-components";
import { Theme } from "../../themes/theme";
import H2 from "../text/H2";

const Wrapper = styled.div`
  width: 100%;
  min-height: 430px;
  background-color: ${Theme.color.background.red};
  position: relative;
  border-radius: ${Theme.border.borderRadius.md};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 32px 0 0;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-6px);
  }

  h2 {
    font-size: ${Theme.font.fontSize.xl};

    @media (max-width: 768px) {
      font-size: ${Theme.font.fontSize.lg};
    }
  }

  @media (max-width: 768px) {
    min-height: 340px;
  }
`;

const Content = styled.div`
  box-sizing: border-box;
  padding: 0 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  p {
    margin: 0;
    line-height: 1.6;
    color: ${Theme.color.text.secondary};
    font-size: ${Theme.font.fontSize.sm};
  }

  @media (max-width: 768px) {
    padding: 0 22px;
  }
`;

const Badge = styled.div`
  background-color: ${Theme.color.text.primary};
  height: 56px;
  width: 56px;
  margin-left: 28px;
  margin-bottom: 24px;
  border-radius: ${Theme.border.borderRadius.md};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  h2 {
    color: ${Theme.color.text.inverse};
    margin: 0;
  }

  @media (max-width: 768px) {
    margin-left: 22px;
    height: 48px;
    width: 48px;
  }
`;

const Image = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  margin-top: 24px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: bottom center;
    display: block;
    max-height: 200px;
/* 
    @media (max-width: 768px) {
      max-height: 150px;
    } */
  }
`;

function WorkingStepsCard({ index, title, desc, img }) {
  return (
    <Wrapper>
      <div>
        <Badge>
          <H2>{index}</H2>
        </Badge>
        <Content>
          <H2>{title}</H2>
          <p>{desc}</p>
        </Content>
      </div>
      <Image>
        <img src={img} alt={title} />
      </Image>
    </Wrapper>
  );
}

export default WorkingStepsCard;